var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-dropdown-section',{attrs:{"title":"Offers Near Me","type":"locum-offers-near-me","items-shown":5,"items":_vm.offers,"event-name":"load-locum-offers-near-me"},on:{"load-locum-offers-near-me":_vm.loadMore}})}
var staticRenderFns = []

export { render, staticRenderFns }